<template>
    <div>
        <h3 class="form-section" style="margin-top: 10px">Multimedia</h3>
        <div class="row">
            <div class="col-md-12">
                <div v-for="(i, key) in actualMultimediaNumber" id="multimedia_files" :key="key" class="row">
                    <div v-if="multimedia[i - 1] != undefined" class="col-md-11 col-md-offset-1">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="text-center">
                                    <img
                                        v-if="multimedia[i - 1].uploaded && multimedia[i - 1].isImage"
                                        :src="multimediaTempDir + multimedia[i - 1].name"
                                        class="img-responsive img-thumbnail"
                                        style="max-height: 160px;"
                                    />
                                    <img
                                        v-if="!multimedia[i - 1].uploaded && multimedia[i - 1].isImage"
                                        :src="multimediaDir + multimedia[i - 1].name"
                                        class="img-responsive img-thumbnail"
                                        style="max-height: 160px;"
                                    />
                                    <img
                                        v-if="multimedia[i - 1].uploaded && !multimedia[i - 1].isImage"
                                        src="/assets/image_default.png"
                                        class="img-responsive img-thumbnail"
                                        style="max-height: 160px;"
                                    />
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="row" style="margin-bottom: 5px;">
                                    <div class="col-md-3">
                                        <label class="control-label">Plik</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input
                                            type="text"
                                            :value="multimedia[i - 1].name"
                                            class="form-control"
                                            readonly
                                            style="border: none; margin-top: -1px;"
                                        />
                                    </div>
                                </div>

                                <div class="row" style="margin-bottom: 5px;">
                                    <div :class="multimedia[i - 1].fileNameErrorClass">
                                        <div class="col-md-3">
                                            <label class="control-label">Nazwa pliku</label>
                                        </div>
                                        <div class="col-md-9">
                                            <input
                                                v-model="multimedia[i - 1].fileName"
                                                type="text"
                                                class="form-control"
                                                :disabled="blockingFieldEditing"
                                            >
                                            <!--<span class="help-block" v-if="multimedia[i - 1].fileNameError">-->
                                                <!--<p> {{ multimedia[i - 1].fileNameError }} </p>-->
                                            <!--</span>-->
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-bottom: 5px;">
                                    <div class="col-md-3">
                                        <label class="control-label">Opis pliku</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input
                                            v-model="multimedia[i - 1].description"
                                            type="text"
                                            class="form-control"
                                            :disabled="blockingFieldEditing"
                                        >
                                    </div>
                                </div>

                                <div class="row">
                                    <div :class="multimedia[i - 1].tagErrorClass">
                                        <div class="col-md-3">
                                            <label class="control-label">Tagi pliku</label>
                                        </div>
                                        <div class="col-md-9">
                                            <multiselect
                                                v-model="multimedia[i - 1].tag"
                                                :checked="multimedia[i - 1].selectedTags"
                                                :options="tags"
                                                label="value"
                                                :disabled="blockingFieldEditing"
                                            >
                                            </multiselect>
                                            <span v-if="multimedia[i - 1].tagError" class="help-block">
                                                <p> {{ multimedia[i - 1].tagError }} </p>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="text-right">
                                    <button
                                        v-if="!multimedia[i - 1].isTempUpload"
                                        type="button"
                                        class="btn btn-info"
                                        @click="downloadFile(multimedia[i - 1].name, false, false)"
                                    >
                                        Pobierz
                                    </button>
                                    <button
                                        v-if="multimedia[i - 1].isTempUpload"
                                        type="button"
                                        class="btn btn-info"
                                        @click="downloadFile(multimedia[i - 1].name, multimedia[i - 1].fileName, true)"
                                    >
                                      Pobierz
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="removeMultimedia(i - 1)"
                                        :disabled="blockingFieldEditing"
                                    >
                                      Usuń
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden">
                    <input id="mediaUploader" type="file" @change="uploadFile">
                </div>
                <button
                    type="button"
                    class="btn btn-default"
                    @click="uploadMultimedia"
                    :disabled="blockingFieldEditing"
                >Dodaj plik...</button>
                <span v-if="errorText" class="help-block">
                    <p> {{errorText}} </p>
                </span>

            </div>

        </div>
    </div>
</template>

<script>
import Multiselect from '../../component/dccore-form/multiselect.vue'

export default {
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Array,
      default: null
    },
    multimediaDir: {
      type: String,
      default: '/upload/multimedia/'
    },
    multimediaTempDir: {
      type: String,
      default: '/upload/tmp/'
    },
    errors: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: Translator.trans('multimedia.title')
    },
    blockingFieldEditing: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      multimedia: [],
      actualMultimediaNumber: 0,
      tags: [],
      errorText: false,
      formGroupClass: '',
      tagError: false,
    }
  },
  watch : {
    errors: function() {

    },
    value: function(value) {
      if (value) {
        this.actualize()
      }
    },
  },
  beforeMount: function() {
    this.getTags()
  },
  mounted: function() {
    this.actualize()
  },
  methods: {
    actualize: function () {
      this.multimedia = this.value
      this.actualMultimediaNumber = Object.keys(this.multimedia).length
      this.$emit('input', this.multimedia)
    },
    uploadFile: function (e) {
      let files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.$emit('input', null)
        //                    toastr.error(Translator.trans('form.errors.invalid_file'));
        return
      }

      let formData = new FormData()
      formData.append('file', files[0])

      let url = Routing.generate('api_file_multimedia_upload')

      this.$http.post(url, formData)
        .then(response => {
          this.addMultimedia(response.data)
          this.$emit('input', this.multimedia)
        })
    },
    downloadFile: function(fileName, originalFileName, isTemp) {
      let url = Routing.generate('multimedia_file_download', { 'fileName': fileName })

      if (isTemp) {
        url = Routing.generate('multimedia_file_download', { 'fileName': fileName,
          'originalName': originalFileName,
          'isTemp': 'isTemp' })
      }

      window.location.href = url
    },
    addMultimedia(data) {
      this.multimedia[this.actualMultimediaNumber] = {
        id: null,
        fileName: data.originalFileName,
        name: data.name,
        ext: data.ext,
        description: null,
        tag: [],
        uploaded: true,
        isImage: data.isImage,
        isTempUpload: data.isTempUpload,
        tagError: null,
        tagErrorClass: '',
        fileNameError: null,
        fileNameErrorClass: '',
      }
      this.actualMultimediaNumber++
    },
    removeMultimedia(no) {
      delete this.multimedia[no]
      this.actualMultimediaNumber++
      this.actualMultimediaNumber--
    },
    uploadMultimedia() {
      $('#mediaUploader').click()
    },
    getTags() {
      let url = Routing.generate('api_get_tags', { type: 'multimedia',
        context: 'dropdown' })
      this.loading++
      this.$http.get(url).then(response => {
        this.tags = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
      })
    },
    errorCheck() {
      let hasErrors = false

      for (let x = 0; x < this.multimedia.length; x++) {
        if (this.multimedia[x] !== undefined) {
          if (this.multimedia[x].tag.length <= 0 || this.multimedia[x].tag === undefined || this.multimedia[x].tag === null) {
            hasErrors = true

            this.multimedia[x].tagError = 'Ta wartość nie może być pusta'
            this.multimedia[x].tagErrorClass = 'has-error'
          } else {
            this.multimedia[x].tagError = null
            this.multimedia[x].tagErrorClass = ''
          }

          if (this.multimedia[x].fileName === '' || this.multimedia[x].fileName === undefined || this.multimedia[x].fileName === null) {
            hasErrors = true

            this.multimedia[x].fileNameError = 'Ta wartość nie może być pusta'
            this.multimedia[x].fileNameErrorClass = 'has-error'
          } else {
            this.multimedia[x].fileNameError = null
            this.multimedia[x].fileNameErrorClass = ''
          }
        }
      }

      this.$forceUpdate()

      return hasErrors
    }
  },
}
</script>
